import {
  Button,
  FormControl,
  FormErrorMessage,
  Grid,
  Box,
  Center,
  Input,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
  Stack,
  Avatar,
  AvatarBadge,
  IconButton,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useRef, useState } from "react";
import { AiOutlineCamera, AiOutlineUser } from "react-icons/ai";
import { createAccount, sendFirebaseIdToBackend } from "./service";
import { db } from "../../service/firebase";
import { useGetState } from "../../context/useGetState";
import { setDoc, doc, getDoc, updateDoc } from "@firebase/firestore";
import { errorNotifier, successNotifier } from "../..";
import { useEffect } from "react";
import { _CLEAR_ALL_SESSIONS } from "../signin/SignIn";
import { ImBackward, ImForward2 } from "react-icons/im";
import splash from "../../assets/splash.jpg";
import image from "../../assets/image.jpeg";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
const countries = require("countrycitystatejson");

function MoreInfoScreen({ next, prev, totalStep }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const typeStyle = {
    p: "10px 20px",
    bg: "#fff",
    color: "#4F555A",
    cursor: "pointer",
    borderRadius: "5px",
  };
  const inputStyle = {
    bg: "#fff",
    color: "#000",
    _placeholder: { color: "#000" },
  };

  const [img, setImg] = useState("");
  const [show, setShow] = useState(false);
  const [previewImg, setPreviewImg] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [interest, setInterest] = useState("forex");
  const [loading, setLoading] = useState(false);
  const textColor = useColorModeValue("#fff", "#fff");
  const imgRef = useRef(null);
  const { state: globalState, dispatch } = useGetState();
  const [disabled, setDisabled] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!img || !state || !country || interest?.length < 1) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [img, state, country, interest]);

  const submit = async (e) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("picture", img);
    formData.append("state", state);
    formData.append("country", country);
    formData.append("city", city);

    const promise1 = await createAccount(formData, next, setLoading);

    promise1 ? navigate("/register/interests") : navigate("/register/info");
  };
  const readURL = (file) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(e.target.result);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  };

  const handleNext = () => {
    next(); // Call the prev function to go back to EmailScreen
  };

  // Function to handle going back to the previous step
  const handlePrev = () => {
    prev(); // Call the prev function to go back to EmailScreen
    sessionStorage.setItem("totalStep", "moreInfoScreen");
  };

  const stage = sessionStorage.getItem("totalStep");

  return (
    <Center
      backgroundImage={splash}
      h={{
        base: "100vh",
        sm: "100vh",
        md: "100vh",
        lg: "100vh",
        xl: "100vh",
        "2xl": "100vh",
      }}
    >
      <Grid>
        <Box
          as="form"
          onSubmit={handleSubmit(submit)}
          backgroundColor={"#020B19"}
          mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
          mt={{
            base: "2em",
            sm: "2em",
            md: "2em",
            lg: "2em",
            xl: "2em",
            "2xl": "2em",
          }}
          h={{
            base: "90vh",
            sm: "88vh",
            md: "90vh",
            lg: "88vh",
            xl: "80vh",
            "2xl": "80vh",
          }}
          w={{
            base: "100vw",
            sm: "100vw",
            md: "60vw",
            lg: "60vw",
            xl: "60vw",
            "2xl": "60vw",
          }}
          borderWidth={1}
          borderColor={"#66666680"}
          borderRadius={{
            base: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
            "2xl": "24px",
          }}
          boxShadow="lg"
          p={{
            base: "25px",
            sm: "15px",
            md: "40px",
            lg: "25px",
            xl: "25px",
            "2xl": "15px",
          }}
        >
          <Stack
            direction={{ base: "column", md: "row" }}
            mt={{
              base: "-1em",
              sm: "0em",
              md: "-1em",
              lg: "0em",
              xl: "0em",
              "2xl": "2em",
            }}
          >
            <Flex
              p={"2%"}
              color={"white"}
              flex={1}
              align={"center"}
              justify={"center"}
              ml={"5px"}
            >
              <Stack w={"full"} maxW={"md"}>
                <Box w={"268px"} h={"110px"}>
                  <Link to="/register/bio">
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      src={arrow}
                    />
                  </Link>

                  <Heading
                    color={"#ffffff"}
                    paddingTop={1}
                    fontSize={"28px"}
                    fontWeight={500}
                    letterSpacing={0}
                    lineHeight={"normal"}
                  >
                    Personal Details
                  </Heading>
                  <Text
                    fontWeight={400}
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    color={"white"}
                    fontSize={"15px"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                  >
                    Lets know more about you
                  </Text>
                </Box>
                <Flex width="100%" justify="start">
                  {previewImg ? (
                    <Image
                      w="100px"
                      h="100px"
                      maxW={"100px"}
                      borderRadius={"50%"}
                      objectFit="cover"
                      src={previewImg}
                      alt="user upload"
                      onClick={() => imgRef.current.click()}
                      cursor="pointer"
                    />
                  ) : (
                    <Flex
                      justify={"center"}
                      alignItems="center"
                      borderRadius={"50%"}
                      w="100px"
                      h="100px"
                      maxW={"100px"}
                      bg="grey"
                      onClick={() => imgRef.current.click()}
                      cursor="pointer"
                    >
                      <Flex
                        direction={"column"}
                        align="center"
                        justify="center"
                      >
                        <AiOutlineUser color="#fff" size={36} />

                        <FormLabel
                          htmlFor="image"
                          display={"inline-block"}
                          bg="grey"
                          color={"#fff"}
                          fontSize="12px"
                          textAlign={"center"}
                          overflow="hidden"
                          ml="8px"
                        >
                          150 x 150
                        </FormLabel>
                      </Flex>
                    </Flex>
                  )}

                  <Input
                    ref={imgRef}
                    id="image"
                    display={"none"}
                    width={0}
                    height={0}
                    type="file"
                    accept="image/jpeg, image/jpeg, image/png"
                    onChange={async (e) => {
                      setImg(e.target.files?.[0]);
                      setPreviewImg(await readURL(e.target.files?.[0]));
                    }}
                  />
                </Flex>

                <FormControl id="country">
                  <FormLabel
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    fontWeight={400}
                    fontSize={"0.8em"}
                    color={"#d5d5d5"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                  >
                    Select Country
                  </FormLabel>
                  <Input
                    color={"white"}
                    borderColor={"#66666680"}
                    variant={"outline"}
                    borderWidth={1}
                    backgroundColor={"#020B19"}
                    placeholder="Country"
                    list="browsers"
                    name="country"
                    onChange={(e) => {
                      setCountry(e.target.value);
                    }}
                  />
                  <datalist id="browsers">
                    {countries.getCountries()?.map((data, idx) => {
                      return <option key={idx} value={data?.name} />;
                    })}
                  </datalist>

                  {errors.country && <span>This field is required</span>}
                </FormControl>

                <Flex gap={4}>
                  <FormControl id="state">
                    <FormLabel
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      State
                    </FormLabel>
                    <Box>
                      <Input
                        color={"white"}
                        borderColor={"#66666680"}
                        variant={"outline"}
                        borderWidth={1}
                        backgroundColor={"#020B19"}
                        name="state"
                        list="browsers2"
                        type="text"
                        placeholder="State"
                        value={state}
                        autoComplete="off"
                        onChange={(e) => setState(e.target.value)}
                      />
                      <datalist id="browsers2">
                        {countries
                          .getStatesByShort(
                            countries
                              .getCountries()
                              .find((data) => data.name === country)?.shortName
                          )
                          ?.map((data, idx) => {
                            return <option key={idx} value={data} />;
                          })}
                      </datalist>
                    </Box>
                  </FormControl>
                  <FormControl id="city">
                    <FormLabel
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      {" "}
                      City
                    </FormLabel>
                    <Input
                      name="city"
                      onChange={(e) => setCity(e.target.value)}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="text"
                    />
                    {errors.city && <span>This field is required</span>}
                  </FormControl>
                </Flex>

                <Stack spacing={6}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  ></Stack>
                  <Stack
                    align={{
                      base: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                      xl: "end",
                      "2xl": "end",
                    }}
                  >
                    <Button
                      borderRadius={24}
                      bg={"#0076FF"}
                      w={"150px"}
                      type="submit"
                      h={"50px"}
                      variant={"solid"}
                    >
                      {loading ? <Spinner /> : "Continue"}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Flex>

            <Flex
              justify="center"
              align="center"
              display={["none", "none", "none", "flex"]}
            >
              <Image
                alt={"Login Image"}
                marginTop={6}
                height={"350px"}
                width={"250px"}
                objectFit={"cover"}
                src={logo}
              />
            </Flex>
          </Stack>
        </Box>
        <Flex mr={5} ml={5} justify={"space-between"}>
          <Box>
            <Select
              fontFamily={("Poppins-Regular", "Helvetica")}
              fontSize={".9em"}
              color={"white"}
              w="auto"
            >
              <option value="en"> English(Unites states)</option>
            </Select>
          </Box>
          <Box mt={2}>
            <Flex mr={10} justify={"space-evenly"}>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                color={"white"}
              >
                Help
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Privacy
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Terms
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Grid>
    </Center>
  );
}

export default MoreInfoScreen;
